import {
    DELETE_NON_VERIFIED,
    GET_ADMIN_CATEGORY_TYPE_URL,
    GET_INSITUTION_CATEGORY_URL,
    INSERT_INCORRECT_VERIFICATION_FORM_URL
} from "../../../config/adminUrlConfig";
import { ApiService } from "../../../config/apiServices";

export const getAdminCategoryType = (typeId) => {
    return ApiService.get(`${GET_ADMIN_CATEGORY_TYPE_URL}/${typeId}`);
  };

  export const getInsitutionCategoryType = (subCategoryType, orgDistrict) => {
    return ApiService.get(`${GET_INSITUTION_CATEGORY_URL}?category_type=${subCategoryType}&orgnization_city_id=${orgDistrict}`);
  };

export const  deleteNonVerifiedUserData  = (data) => {
    return ApiService.post(DELETE_NON_VERIFIED,data);
}

